import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../lib/language";

export const Footer = () => {
  const { t, lang, setLang } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-resilie-bg border-t border-resilie-line px-6 md:px-12 pt-20 pb-10"
    >
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Brand */}
        <div className="md:col-span-2">
          <p className="font-serif tracking-[0.42em] uppercase font-light text-2xl md:text-3xl text-resilie-ink">
            RESILIÉ
          </p>
          <p className="mt-4 font-sans text-[11px] tracking-[0.32em] uppercase text-resilie-muted">
            {t.footer.tagline}
          </p>
          <p className="mt-8 max-w-sm font-sans text-sm leading-relaxed text-resilie-muted">
            Estd. 2024 — Atelier work between Portugal & Northern Italy.
          </p>
        </div>

        {/* Follow */}
        <div>
          <p className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-ink mb-5">
            {t.footer.sections.follow}
          </p>
          <ul className="space-y-3">
            <li>
              <a
                href="https://instagram.com/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="nav-link"
              >
                {t.footer.links.instagram}
              </a>
            </li>
            <li>
              <a
                href="https://pinterest.com/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-pinterest"
                className="nav-link"
              >
                {t.footer.links.pinterest}
              </a>
            </li>
          </ul>
        </div>

        {/* Contact / Legal */}
        <div>
          <p className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-ink mb-5">
            {t.footer.sections.contact}
          </p>
          <ul className="space-y-3">
            <li>
              <a
                href={`mailto:${t.footer.links.email}`}
                data-testid="footer-email"
                className="nav-link normal-case tracking-[0.12em] lowercase"
              >
                {t.footer.links.email}
              </a>
            </li>
          </ul>
          <p className="font-sans text-[10px] tracking-[0.4em] uppercase text-resilie-ink mt-8 mb-5">
            {t.footer.sections.legal}
          </p>
          <ul className="space-y-3">
            <li>
              <Link
                to="/impressum"
                data-testid="footer-imprint"
                className="nav-link"
              >
                {t.footer.links.imprint}
              </Link>
            </li>
            <li>
              <Link
                to="/datenschutz"
                data-testid="footer-privacy"
                className="nav-link"
              >
                {t.footer.links.privacy}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-resilie-line flex flex-col md:flex-row items-center justify-between gap-4">
        <p
          data-testid="footer-copyright"
          className="font-sans text-[10px] tracking-[0.32em] uppercase text-resilie-muted"
        >
          © {year} RESILIÉ — {t.footer.copyright}
        </p>

        <div className="flex items-center gap-3 text-resilie-ink">
          <button
            type="button"
            data-testid="footer-lang-de"
            onClick={() => setLang("de")}
            className={`nav-link ${lang === "de" ? "is-active" : "opacity-60"}`}
          >
            DE
          </button>
          <span className="opacity-40 text-[10px]">/</span>
          <button
            type="button"
            data-testid="footer-lang-en"
            onClick={() => setLang("en")}
            className={`nav-link ${lang === "en" ? "is-active" : "opacity-60"}`}
          >
            EN
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
